import * as z from "zod";

export const setMerchantZonosIntegration = {
  name: "setMerchantZonosIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    apiKey: z.string().trim().min(1).optional(),
  }),
  output: z.null(),
};
